/**
 * ScribeStatsTracker
 *
 * This module is reponsible for tracking basic performance statistics of
 * activity in Scribe.
 *
 * @module    scribe_stats_tracker
 * @author    Brian LaMattina <blamattina@wayfair.com>
 * @copyright 2016 Wayfair, LLC - All rights reserved
 */
import _ from 'underscore';

/**
 * Construct Scribe Stats Tracker object
 *
 * @class
 */
class ScribeStatsTracker {
  constructor() {
    this.inflightAtTimeOfReset = 0;
    this.resetStats();
  }

  /**
   * Reset stats
   */
  resetStats() {
    this.requestsMade = 0;
    this.requestsFailed = 0;
    this.requestsCompleted = 0;
    this.durationOfSuccessfulRequests = 0;
  }

  /**
   * Track the progress of this request
   *
   * @param {$.Deferred} scribeRequestPromise a ScribeDataClient promise
   */
  trackRequest(scribeRequestPromise) {
    this.requestsMade++;
    scribeRequestPromise.then(this._trackSuccess, this._trackFailure);
  }

  /**
   * Return current statistics
   *
   * @return {Object} stats object
   */
  getStats() {
    return {
      requestsMade: this.requestsMade,
      meanResponseTimeInMs: this._getMeanResponseTimeInMs(),
      requestsCompleted: this.requestsCompleted,
      requestsFailed: this.requestsFailed,
    };
  }

  _getMeanResponseTimeInMs() {
    const meanResponseTimeInMs = Math.round(
      this.durationOfSuccessfulRequests / this.requestsCompleted
    );
    return meanResponseTimeInMs || 0;
  }

  /**
   * This function uses arrow syntax because it is used as a callback, and we would
   * like __this__ to refer to the enclosing class
   *
   * @param scribeEvent
   * @private
   */
  _trackSuccess = scribeEvent => {
    this.requestsCompleted++;
    this.durationOfSuccessfulRequests += _.now() - scribeEvent.getTimestamp();
  };

  /**
   * This function uses arrow syntax because it is used as a callback, and we would
   * like __this__ to refer to the enclosing class
   *
   * @private
   */
  _trackFailure = () => {
    this.requestsFailed++;
  };
}

export default ScribeStatsTracker;
